import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n/I18nContext.jsx';

/**
 * Redirects bare paths (without a language prefix) to their
 * language-prefixed equivalents.
 *
 *   /pricing        → /en/pricing  (or /es/pricing if cookie/navigator says es)
 *   /dashboard?code=abc → /en/dashboard?code=abc
 *   /               → /en
 */
export default function LangRedirect() {
  const location = useLocation();
  const { lang } = useTranslation();

  const bare = location.pathname === '/' ? '' : location.pathname;
  const target = `/${lang}${bare}${location.search}${location.hash}`;

  return <Navigate to={target} replace />;
}
